module.exports = __webpack_public_path__ + "img/parachute-octobre-7.ee9bcadd.jpg";